(function() {
  var LOW = 5;
  var map = {};

  var docLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  var IS_FR = docLang.indexOf('fr') === 0 || location.hostname.indexOf('lumieredecor') > -1;

  var T = IS_FR ? {
    inStock: 'en stock',
    lowPre: 'Plus que ',
    lowUnit1: ' pièce disponible',
    lowUnitN: ' pièces disponibles',
    tagline: 'Une collection unique de lampes Tiffany, choisies avec soin pour leur qualité, leur caractère et leur atmosphère.',
    features: '✨ Verre véritable · 💡 Ampoule LED incluse · Livraison gratuite 🇫🇷🇧🇪'
  } : {
    inStock: 'op voorraad',
    lowPre: 'Nog ',
    lowUnit1: ' stuk beschikbaar',
    lowUnitN: ' stuks beschikbaar',
    tagline: 'Een unieke collectie Tiffany lampen, zorgvuldig gekozen met oog voor kwaliteit, karakter en sfeer.',
    features: '✨ 100% echt glas · 💡 Inclusief LED · Gratis verzending 🇳🇱🇧🇪'
  };

  [].forEach.call(document.scripts, function(s) {
    var m = s.text.match(/var inventoryMap\s*=\s*\{([\s\S]*?)\}/);
    if (m) {
      m[1].replace(/"(\d+)":\s*(\d+)/g, function(_, id, qty) {
        map[id] = +qty;
      });
    }
  });

  function update(label, qty) {
    if (qty > LOW) {
      label.innerHTML = '<span class="stock-counter__dot" style="background:#27ae60;animation:none;box-shadow:none"></span>' + T.inStock;
    } else {
      var unit = qty === 1 ? T.lowUnit1 : T.lowUnitN;
      label.innerHTML = '<span class="stock-counter__dot"></span>' + T.lowPre + '<strong style="color:#c0392b">' + qty + '</strong>' + unit;
    }
  }

  var BULB_28 = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="28" height="28"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.1 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg>';
  var BULB_22 = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="22" height="22"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.1 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg>';

  var style = document.createElement('style');
  style.textContent = [
    '.collection-hero .media {',
    '  max-height: 45vh !important;',
    '  min-height: 220px !important;',
    '}',
    '@media (max-width: 749px) {',
    '  .collection-hero .media {',
    '    max-height: 42vh !important;',
    '    min-height: 180px !important;',
    '  }',
    '}',
    '@media (max-width: 749px) {',
    '  .collection-hero__title {',
    '    font-size: 7vw !important;',
    '    line-height: 1.2 !important;',
    '    white-space: nowrap !important;',
    '  }',
    '}',
    '.custom-tagline {',
    '  display: block;',
    '  background: #f2e9dc;',
    '  padding: 28px 32px 12px 32px;',
    '  text-align: center;',
    '  font-size: 17px;',
    '  font-weight: 400;',
    '  color: #3d2b1a;',
    '  line-height: 1.8;',
    '  width: 100%;',
    '  box-sizing: border-box;',
    '  letter-spacing: 0.01em;',
    '}',
    '@media (max-width: 749px) {',
    '  .custom-tagline {',
    '    display: none !important;',
    '  }',
    '}',
    '.custom-features-bar {',
    '  display: block;',
    '  background: #f2e9dc;',
    '  padding: 10px 32px 16px 32px;',
    '  text-align: center;',
    '  font-size: 16px;',
    '  font-weight: 700;',
    '  color: #3d2b1a;',
    '  letter-spacing: 0.03em;',
    '  width: 100%;',
    '  box-sizing: border-box;',
    '}',
    '@media (max-width: 749px) {',
    '  .custom-features-bar {',
    '    font-size: 11px;',
    '    font-weight: 700;',
    '    padding: 14px 12px 14px 12px;',
    '    white-space: nowrap;',
    '    overflow: hidden;',
    '  }',
    '}',
    '/* Mobile: give every product card the same title block so price,',
    '   star rating and add-to-cart button line up across the grid. */',
    '@media (max-width: 749px) {',
    '  .card-information__wrapper .card-information__text {',
    '    display: -webkit-box;',
    '    -webkit-box-orient: vertical;',
    '    -webkit-line-clamp: 3;',
    '    overflow: hidden;',
    '    font-size: 14px;',
    '    line-height: 1.3;',
    '    height: 54.6px;',
    '  }',
    '  .card-information__wrapper .price {',
    '    min-height: 24px;',
    '  }',
    '  .card-information__wrapper:not(:has(.rating)) .price {',
    '    margin-bottom: 27px;',
    '  }',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.stock-counter').forEach(function(c) {
      var l = c.querySelector('.stock-counter__label');
      var s = l && l.querySelector('strong');
      if (l && s) update(l, +s.textContent || 0);
    });

    var features = document.querySelectorAll('.product-icon-feature');
    if (features[1]) {
      var iconEl = features[1].querySelector('.product-icon-feature__icon');
      if (iconEl) iconEl.innerHTML = BULB_28;
    }

    var stickyFeatures = document.querySelectorAll('.sticky-cart__feature');
    if (stickyFeatures[1]) {
      var svg = stickyFeatures[1].querySelector('svg');
      if (svg) svg.outerHTML = BULB_22;
    }

    var collectionHero = document.querySelector('.collection-hero');
    if (collectionHero) {
      var anchor = collectionHero.closest('.shopify-section') || collectionHero;

      var tagline = document.createElement('div');
      tagline.className = 'custom-tagline';
      tagline.textContent = T.tagline;
      anchor.parentNode.insertBefore(tagline, anchor.nextSibling);

      var bar = document.createElement('div');
      bar.className = 'custom-features-bar';
      bar.textContent = T.features;
      tagline.parentNode.insertBefore(bar, tagline.nextSibling);
    }

    /* Inject wishlist button on product page (code 1: heart + text) */
    if (document.body.classList.contains('template-product')) {
      var addToCartBtn = document.querySelector('.product-form__submit');
      var productEl = document.querySelector('product-recently-viewed[data-product-id]');
      var variantInput = document.querySelector('form input[name="id"]');
      if (addToCartBtn && productEl && variantInput && !document.querySelector('.dsk-product-wishlist')) {
        var wDiv = document.createElement('div');
        wDiv.className = 'wishlist-engine dsk-product-wishlist';
        wDiv.setAttribute('data-product_id', productEl.dataset.productId);
        wDiv.setAttribute('data-variant_id', variantInput.value);
        wDiv.setAttribute('data-full_button', 'true');
        wDiv.setAttribute('data-css', 'true');
        addToCartBtn.parentNode.insertBefore(wDiv, addToCartBtn.nextSibling);
      }
    }
  });

  /* Update wishlist variant ID when variant changes on product page */
  document.addEventListener('variant:changed', function(e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    var w = document.querySelector('.dsk-product-wishlist');
    if (w) w.setAttribute('data-variant_id', String(v.id));
    var qty = map[String(v.id)];
    if (qty == null || qty <= 0) return;
    document.querySelectorAll('.stock-counter .stock-counter__label').forEach(function(l) {
      update(l, qty);
    });
  });
})();

/* ---------- Terug-op-voorraad via Klaviyo (vervangt Mini: Waitlist) ----------
   De ds-bis-overlay (ds-global.js) blijft de UI; alleen het versturen gaat nu
   naar Klaviyo. Capture-fase listener + stopImmediatePropagation, zodat de
   oude Mini-handler in ds-global.js niet meer draait.
   1. profiel bijwerken met bis_locale (nl/fr/de = domein waarop is aangemeld)
   2. back-in-stock-subscription aanmaken (Klaviyo verstuurt bevestiging + restock-mail)
   Klaviyo flows splitsen op properties['bis_locale']. */
(function () {
  if (window.__dsBisKlaviyo) return;
  window.__dsBisKlaviyo = true;

  var COMPANY = 'TQLvWp';
  var REV = '2025-04-15';

  function bisLocale() {
    var h = (location.hostname || '').toLowerCase();
    if (h.indexOf('lumieredecor') > -1) return 'fr';
    if (h.indexOf('tiffanystube') > -1) return 'de';
    var l = (document.documentElement.getAttribute('lang') || 'nl').toLowerCase().slice(0, 2);
    return (l === 'fr' || l === 'de') ? l : 'nl';
  }

  function post(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REV },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok && r.status !== 202) throw new Error(path + ' ' + r.status);
      return r;
    });
  }

  function meldAanKlaviyo(email, variantId) {
    var locale = bisLocale();
    return post('profiles', {
      data: { type: 'profile', attributes: {
        email: email,
        properties: { bis_locale: locale, bis_last_signup: new Date().toISOString() }
      } }
    }).then(function () {
      return post('back-in-stock-subscriptions', {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
        }
      });
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('.ds-bis__form') : null;
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var ov = form.closest('.ds-bis');
    var email = form.querySelector('input[type="email"]').value.trim();
    var variant = ov.dataset.variant;
    var msg = ov.querySelector('.ds-bis__msg');
    var sub = form.querySelector('button[type="submit"]');
    var subLabel = sub.querySelector('span');
    var T = function (k, d) { return (window.dsI18n && window.dsI18n[k] != null) ? window.dsI18n[k] : d; };
    if (!variant) {
      msg.className = 'ds-bis__msg ds-bis__msg--err';
      msg.textContent = T('bis_err', 'Dat lukte even niet. Mail ons op info@desierkamer.nl, dan zetten wij je op de lijst.');
      return;
    }
    sub.disabled = true;
    if (subLabel) subLabel.textContent = T('sending', 'Versturen…');
    meldAanKlaviyo(email, variant).then(function () {
      form.hidden = true;
      msg.className = 'ds-bis__msg ds-bis__msg--ok';
      msg.textContent = T('bis_ok', 'Gelukt! We sturen je één mailtje zodra deze lamp er weer is.');
    }).catch(function (err) {
      if (window.console && console.warn) console.warn('[ds] klaviyo bis', err);
      msg.className = 'ds-bis__msg ds-bis__msg--err';
      msg.textContent = T('bis_err', 'Dat lukte even niet. Mail ons op info@desierkamer.nl, dan zetten wij je op de lijst.');
    }).finally(function () {
      sub.disabled = false;
      if (subLabel) subLabel.textContent = T('keep_posted', 'Houd me op de hoogte');
    });
  }, true);
})();
